module.exports = __webpack_public_path__ + "img/方南.42398161.png";